<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selected='selected' :selectedItem="0">
          <e-tabitems>
            <e-tabitem :header="headerText0" content="#idv1"></e-tabitem>
            <e-tabitem :header="headerText1" content="#idv2"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
      <div id="idv1" style="display: none">
        <AddressUser ref='addressUser'></AddressUser>
      </div>
      <div id="idv2" style="display: none">
        <AddressGroup ref='addressGroup'></AddressGroup>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import AddressUser from "../../components/system/AddressUser";
import AddressGroup from "../../components/system/AddressGroup";

export default {
  name: "AddressBook",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.systemNotice')}/${this.$t('System.addressBook')}` },
      headerText0: { text: `${this.$t('System.user')}` },
      headerText1: { text: `${this.$t('System.uGroup')}` }
    };
  },
  components: {
    BasicLayout,
    AddressUser,
    AddressGroup
  },
  methods: {
    selected(args){
      const index = args.selectedIndex;
      if (index === 0) {
        this.$refs.addressUser.getUserList();
      } else {
        this.$refs.addressGroup.getGroupList();
      }
    },
  },
  mounted() {
    this.$refs.addressUser.getUserList();
  }
};
</script>

<style>
</style>
